import Vue from 'vue';
import store from "@/store";

export default {
    getEmployeeComplianceRemindersSentReport: (startDate, endDate) => {
        return Vue.axios.get(`/api/${store.state.tenantId}/reports/EmployeeComplianceRemindersSentReport?startDate=${startDate}&endDate=${endDate}`)
            .then(resp => resp.data);
    },
};